import React, { MouseEvent, ReactNode } from 'react';
import { CollapsibleButton } from './AccordionHeader.styles';
import { useAccordionContext } from '@/components/accordion/context/AccordionContext';
import { Title } from '@/components/typography';

export interface AccordionHeaderProps {
  targetId: string;
  className?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
}

const AccordionHeader = React.forwardRef<HTMLButtonElement, AccordionHeaderProps>(function AccordionHeader(
  { targetId, children, ...props },
  ref
) {
  const { open, toggle } = useAccordionContext();

  return (
    <Title as="h3" align="left">
      <CollapsibleButton
        ref={ref}
        type="button"
        onClick={(event) => toggle(targetId, event)}
        collapsed={Array.isArray(open) ? open.includes(targetId) : open === targetId}
      >
        {children}
      </CollapsibleButton>
    </Title>
  );
});

export default AccordionHeader;
